/* eslint-disable react/prop-types */
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { Button } from "../ui/button";
import { CheckCircle, Loader2, Minus, Plus, XCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { airtelLogo, etisalatLogo, gloLogo, mtnLogo } from "@/assets";
import { numberPrefix } from "@/constants";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import { useMediaQuery } from "react-responsive";
import { cn } from "@/lib/utils";
import Notiflix from "notiflix";

const DataDrawer = ({
  isFormValid,
  phone,
  network,
  plan,
  loading,
  onSubmit,
  plans,
  handleSubmit,
  openDataDrawer,
  setOpenDataDrawer,
}) => {
  const [isNumberValid, setIsNumberValid] = useState(null);

  const isMobile = useMediaQuery({ query: "(max-width: 400px)" });

  const currentPlan = plans?.find((pp) => pp.id === +plan);

  const formatter = new Intl.NumberFormat("en-NG");

  const validatePhoneNumber = () => {
    if (!phone || !network) return false;
    const selectedNetwork = network?.toLowerCase();
    if (!selectedNetwork) return false;

    const prefix = phone.substring(1, 4);

    return numberPrefix[selectedNetwork]?.includes(prefix) || false;
  };

  useEffect(() => {
    setIsNumberValid(validatePhoneNumber());
  }, [phone, network]);

  const handlePurchaseClick = (e) => {
    e.preventDefault();

    if (phone && network && !isNumberValid) {
      const selectedNetwork = network?.toLowerCase();

      Notiflix.Confirm.show(
        "Number Validation",
        `Our system validator detected that this number is not a ${selectedNetwork} number. Do you wish to continue?`,
        "Yes",
        "No",
        () => {
          // User clicked Yes
          // setOpenDataDrawer(true);
          handleSubmit(onSubmit)();
        },
        () => {
          // User clicked No
          setOpenDataDrawer(false);
        },
        {
          titleColor: "#FF5F57",
          okButtonBackground: "#FF5F57",
          borderRadius: "8px",
        },
      );
    } else {
      handleSubmit(onSubmit)();
    }
  };

  const showImage = (network) => {
    switch (network) {
      case "mtn":
        return (
          <img src={mtnLogo} alt="mtn" className="size-[25px] rounded-full" />
        );
      case "glo":
        return (
          <img src={gloLogo} alt="glo" className="size-[25px] rounded-full" />
        );
      case "airtel":
        return (
          <img
            src={airtelLogo}
            alt="airtel"
            className="size-[25px] rounded-full"
          />
        );
      case "9mobile":
        return (
          <img
            src={etisalatLogo}
            alt="9mobile"
            className="size-[25px] rounded-full"
          />
        );
      default:
        return null;
    }
  };

  // console.log(openDataDrawer);
  return (
    <>
      <button
        type="button"
        className={`bg-primary mt-2 cursor-pointer rounded-md py-2.5 text-white ${!isFormValid && "cursor-not-allowed opacity-50"}`}
        disabled={!isFormValid}
        onClick={() => {
          setOpenDataDrawer(true);
        }}
      >
        {loading ? (
          <div className="flex items-center justify-center gap-2">
            <span className="animate-spin">
              <Loader2 />
            </span>
            <span>Processing...</span>
          </div>
        ) : (
          <span>Preview data purchase</span>
        )}
      </button>
      <Drawer
        open={openDataDrawer}
        onOpenChange={() => {
          setOpenDataDrawer(false);
        }}
      >
        <DrawerContent>
          <div className="mx-auto w-full max-w-sm">
            <div className={cn("space-y-4 py-4", isMobile ? "p-4" : "px-0")}>
              <div className="flex items-center justify-center">
                <h3 className="text-3xl font-semibold">
                  <span className="text-2xl">₦</span>
                  {formatter.format(currentPlan?.price)}.00
                </h3>
              </div>

              <div className="mt-10 flex items-center justify-between">
                <span className="text-sm text-gray-600 dark:text-gray-300">
                  Product Name
                </span>
                <div className="flex items-center gap-1">
                  {showImage(network?.toLowerCase())}
                  <p className="">Mobile Data</p>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-600 dark:text-gray-300">
                  Recipient Mobile
                </span>

                <div className="flex items-center gap-2">
                  <span className="font-medium">{phone}</span>
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger>
                        {" "}
                        {isNumberValid !== null &&
                          (isNumberValid ? (
                            <CheckCircle className="h-5 w-5 text-green-500" />
                          ) : (
                            <XCircle className="h-5 w-5 text-red-500" />
                          ))}
                      </TooltipTrigger>
                      <TooltipContent className="">
                        <p>
                          {isNumberValid
                            ? "Number Validator"
                            : "Number must match selected network provider"}
                        </p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
              </div>

              <div className="items- flex items-center justify-between">
                <span className="text-sm text-gray-600 dark:text-gray-100">
                  Data Bundle
                </span>

                <span className="font-medium">
                  {currentPlan?.capacity} {currentPlan?.duration} Plan
                  {/* {formatter.format(currentPlan?.price)} */}
                </span>
              </div>

              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-600 dark:text-gray-100">
                  Amount
                </span>
                <span className="font-medium">
                  ₦{formatter.format(currentPlan?.price)}
                </span>
              </div>
            </div>

            <DrawerFooter className={cn("", isMobile ? "p-4" : "px-0")}>
              <button
                disabled={loading}
                onClick={handlePurchaseClick}
                className="bg-primary mb-2 cursor-pointer rounded-lg py-2 font-medium text-white disabled:opacity-60"
              >
                {loading ? (
                  <div className="flex items-center justify-center gap-2">
                    <span className="animate-spin">
                      <Loader2 />
                    </span>
                    <span>Processing...</span>
                  </div>
                ) : (
                  <span>Purchase</span>
                )}
              </button>

              <DrawerClose asChild>
                <Button variant="outline">Cancel</Button>
              </DrawerClose>
            </DrawerFooter>
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default DataDrawer;
